<template>
  <div>
    <div class="nav">
      <div class="main_box">
        <div class="logo" @click="toPath('/')">
          <img :src="logo" />
        </div>
        <!-- <div class="welcome">{{welcome}}</div> -->
        <!-- <div class="order_btn" @click="toPath('/checkOrder')">
          <span class="ico"></span>手机号查订单
        </div>-->
        <div class="weChat-login" style="margin-left:8px" @click="toMyOrder('/myOrder')">
          <div class="weChat-box">
            <img src="../assets/images/icon4.png" alt />
            <span>我的订单</span>
          </div>
        </div>
        <div class="weChat-login" v-if="!LoginBtnShow" @click="handleLogin">
          <div class="weChat-box">
            <img src="../assets/images/icon5.png" alt />
            <span>登录</span>
          </div>
        </div>
        <div class="weChat-login" style="margin-left:8px" v-if="LoginBtnShow" @click="toPath('/')">
          <div class="weChat-box">
            <img src="../assets/images/icon4.png" alt />
            <span>首页</span>
          </div>
        </div>
      </div>
      <div class="home_btn" v-if="LoginBtnShow">
        <div class="name-box">
          <!-- <span>{{thirdInfo.nickName}}</span> -->
          <span class="hidden-mobile">{{mobile}}</span>
          <img class="icon1" src="../assets/images/icon5.png" alt />
          <img class="icon2" src="../assets/images/icon6.png" alt />
          <div class="hidden-btn">
            <span @click="toRegist(3)">修改密码</span>
            <span @click="handleLogOut">退出</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="banner" v-if="banner">
      <el-carousel trigger="click">
        <el-carousel-item v-for="item in banner" :key="item">
          <img :src="item" class="banner-img" />
        </el-carousel-item>
      </el-carousel>
    </div>-->
  </div>
</template>

<script>
import { config } from '@/constant/config'
export default {
  data () {
    return {
      thirdInfo: {
        headImgUrl: '',
        nickName: '',
        mobile: null
      }
    }
  },
  props: ['homeBtnHide', 'LoginBtnShow', 'banner', 'welcome', 'logo'],
  created () {
    this.thirdInfo = sessionStorage.getItem('thirdInfo') ? JSON.parse(sessionStorage.getItem('thirdInfo')) : {}
    if (this.LoginBtnShow) {
      this.mobile = sessionStorage.getItem('mobile')
    }
  },
  watch: {
    'LoginBtnShow': function () {
      if (this.LoginBtnShow) {
        this.mobile = sessionStorage.getItem('mobile')
      }
    }
  },
  methods: {
    toMyOrder () {
      if (this.LoginBtnShow) {
        this.$router.push('/myOrder')
      } else {
        this.$emit('handleLogin', '/myOrder')
      }
    },
    toPath (path) {
      this.$router.push(path)
    },
    toRegist (i) {
      this.$emit('registShowEvent', i)
    },
    handleLogin () {
      this.$emit('handleLogin')
    },
    handleLogOut () {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('loginState')
      this.LoginBtnShow = false
    }
  }
}
</script>

<style scoped lang="scss">
.nav {
  background-color: #241008;
  position: relative;
  height: 80px;
  line-height: 80px;
  z-index: 2;
}
.nav .main_box {
  position: relative;
  z-index: 9;
  height: 80px;
}
.nav .logo {
  // width: 188px;
  height: 52px;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -26px;
}
.nav .logo img {
  width: 100%;
  height: 50px;
}
.nav .welcome {
  font-size: 14px;
  color: #fff;
  padding-left: 15px;
  position: absolute;
  left: 120px;
}

.nav .order_btn {
  float: right;
  width: 155px;
  height: 50px;
  line-height: 50px;
  color: #fff;
  background-color: #ffb000;
  text-align: center;
  cursor: pointer;
}

.nav .order_btn:hover {
  background-color: #faab00;
}

.nav .order_btn .ico {
  display: inline-block;
  vertical-align: top;
  width: 15px;
  height: 22px;
  margin-top: 14px;
  margin-right: 5px;
  background-image: url(../assets/images/mobile.png);
}

.nav .home_btn {
  z-index: 2000;
  position: absolute;
  top: 50%;
  right: 10px;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  box-sizing: border-box;
  text-align: center;
  .name-box {
    position: relative;
    display: block;
    padding: 0 15px;
    height: 36px;
    line-height: 36px;
    background: #fff;
    color: #bf932f;
    font-size: 16px;
    border-radius: 6px;
    cursor: pointer;
    .hidden-mobile {
      display: none;
    }
    &:hover {
      .hidden-btn {
        display: block;
      }
      .hidden-mobile {
        display: inline-block;
      }
    }
    span {
      display: inline-block;
      vertical-align: middle;
      font-size: 16px;
    }
    .icon1 {
      display: inline-block;
      width: 20px;
      height: 22px;
      vertical-align: middle;
      margin: 0 6px 0 16px;
    }
    .icon2 {
      display: inline-block;
      width: 9px;
      height: 5px;
      vertical-align: middle;
    }
  }
  .hidden-btn {
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    text-align: center;
    padding-top: 4px;
    display: none;
    span {
      height: 36px;
      font-size: 16px;
      color: #bf932f;
      background: #fff;
      border-bottom: 1px solid;
      line-height: 36px;
      z-index: 100;
      display: block;
      width: 100%;
    }
  }
}

.nav .home_btn .ico {
  display: inline-block;
  vertical-align: top;
  margin-top: 6px;
  margin-right: 3px;
  width: 20px;
  height: 20px;
  background-image: url(../assets/images/home.png);
}

.banner {
  position: relative;
  z-index: 1;
  width: 100%;
  min-width: 1200px;
  height: 483px;
  overflow: hidden;
}
.el-carousel.el-carousel--horizontal {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.banner-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
.weChat-login {
  float: right;
  width: 79px;
  height: 65px;
  line-height: 65px;
  background: rgba(255, 255, 255, 1);
  border-radius: 0px 0px 6px 6px;
  text-align: center;
  cursor: pointer;
}
.weChat-box {
  display: inline-block;
  vertical-align: middle;
  line-height: 0;
}
.weChat-box img {
  display: inline-block;
  width: 27px;
  height: 22px;
}
.weChat-box span {
  display: inline-block;
  width: 100%;
  height: 18px;
  font-size: 14px;
  margin-top: 8px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 18px;
  color: #241008;
}
</style>
